import firebase from "firebase/app";
import "firebase/database";
// import "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDVYrLlMtQ1S_muv2LrLVl6sx1AeXrwDqo",
    authDomain: "generator-draw-animals.firebaseapp.com",
    databaseURL: "https://generator-draw-animals.firebaseio.com",
    projectId: "generator-draw-animals",
    storageBucket: "generator-draw-animals.appspot.com",
    messagingSenderId: "42603881210",
    appId: "1:42603881210:web:4a32276f401d155c4e9f43",
    measurementId: "G-Y50K336VKC"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

// const firestore = firebaseApp.firestore();

// firestore.settings({ timestampsInSnapshots: true });
const database = firebaseApp.database();

export default database;
